import Logo from '@cx-web/components/primitives/Logo';

import { type Repub } from '@cx-modules/types';

import { HomeIconLink } from './HomeIconLink';
import { OcLogo } from './OcLogo';

export function ErrorWithoutTranslation({
  baseUrl,
  errorStatus,
  repub,
  rootLoaderData,
}: {
  baseUrl: string;
  errorStatus: number | null;
  repub: Repub;
  rootLoaderData: any;
}) {
  const errorStatusText = errorStatus === 404 ? '404' : '500';

  return (
    <div className="errorGrid" data-testid="errorWithoutTranslations">
      <div className="mainLogo">
        <Logo resourcesUrl={rootLoaderData?.resourcesUrl ?? 'https://cx-resources.oddschecker.com/public'} />
      </div>
      <div className="ocLogo">
        <OcLogo />
      </div>
      <div className="errorStatusText" data-testid="errorStatusText">
        {errorStatusText}
      </div>
      <div className="homeIcon">
        <HomeIconLink baseUrl={baseUrl} repub={repub} />
      </div>
    </div>
  );
}
